import { useQuery } from 'react-query';
import { usePersonId } from 'src/components/providers/PersonIdProvider';
import { api } from '../../helpers';
export const useAnamnesisFromHistory = ({
  anamnesisHistoryReferenceId,
  onSuccess,
  enabled = true
}) => {
  const personReferenceId = usePersonId();
  return useQuery(['anamnesis_history_json', personReferenceId, anamnesisHistoryReferenceId], () => api.ana.getAnamnesisFromHistory({
    personReferenceId,
    anamnesisHistoryReferenceId
  }).then(res => {
    onSuccess && onSuccess(res);
    return res;
  }), {
    enabled: enabled && Boolean(personReferenceId && anamnesisHistoryReferenceId)
  });
};